<template>
  <div class="sign-home">
		<NavBar :navList="NavList" :logoUri="logoUri" routerName="home" title="我的工作台">
			<MyProperty></MyProperty>
		</NavBar>
		<div class="sign-page-content" >
			<router-view class="child"></router-view>
		</div>
		<div class="sign-bottom">
			<BottomBar></BottomBar>
		</div>
  </div>
</template>

<script>
import NavBar from '@/views/navbars/NavBar.vue'
import BottomBar from '@/views/bottombar/BottomBar.vue'
import MyProperty from '@/views/navbars/MyProperty.vue'

export default {
  name: 'home',
  data(){
    return {
      NavList:[
       		{
				index: "/workbench/signDocument",
				title: "文件签署"
			}
    	],
    	logoUri:require("@/assets/img/workbench.png"),
    	height:500
    } 
  },
  created(){
  	this.height = this.$store.state.pageViewHeigh;
  },
  components: {
    NavBar,BottomBar,MyProperty
  }
}
</script>

<style scoped lang="scss">
.sign-home{
	height: 100%;
	background-color: $bg-color;
	position: relative;
}
.sign-page-content{
	height: -webkit-calc(100% - 196px);
	height: -moz-calc(100% - 196px);
	height: calc(100% - 196px);
}
</style>

